import * as z from "zod";

const processorLeaderboardRowSchema = z.object({
  userId: z.string(),
  name: z.string(),
  itemsProcessed: z.number(),
  /** Hours spent processing: time between finished items, leaving out gaps over 20 minutes such as breaks. */
  activeHours: z.number(),
  itemsPerHour: z.number().nullable(),
  fails: z.number(),
  dpmo: z.number().nullable(),
  aboveTarget: z.boolean(),
});

/** Every processor in the range, including any beyond the row cap. */
const processorLeaderboardTotalsSchema = z.object({
  itemsProcessed: z.number(),
  processorCount: z.number(),
  /** Sum of each processor's active hours, so breaks never count. */
  personHours: z.number(),
  itemsPerPersonHour: z.number().nullable(),
  /** Every attributed fail in the range, matching the QA dashboard. */
  fails: z.number(),
  dpmo: z.number().nullable(),
  aboveTarget: z.boolean(),
});

export const getProcessorLeaderboard = {
  name: "getProcessorLeaderboard" as const,
  input: z.object({
    startDate: z.date(),
    endDate: z.date(),
    returnsCenterId: z.string().optional(),
    teamIds: z.array(z.string()).optional(),
  }),
  output: z.object({
    dpmoTarget: z.number(),
    criteriaCount: z.number(),
    totals: processorLeaderboardTotalsSchema,
    /** Only processors who finished at least one item in the range. */
    rows: z.array(processorLeaderboardRowSchema),
    truncated: z.boolean(),
  }),
};

export type ProcessorLeaderboard = z.infer<
  (typeof getProcessorLeaderboard)["output"]
>;
export type ProcessorLeaderboardRow = z.infer<
  typeof processorLeaderboardRowSchema
>;
